import { Consents } from "../types";

export interface ConsentProviderInterface {
  consentGiven: Promise<Consents>;
}
